import cx from "classnames";
import { FC, MouseEventHandler, SVGProps } from "react";

import ChevronRight from "atoms/icon/icons/ic_chevron_right_small_ol.svg";
import { isDarkColorRgb } from "toolbox/Colors";

import { Icon } from "../icon/Icon";

type BannerProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  startIconSVG?: FC<SVGProps<SVGSVGElement>>;
  backgroundColor?: string;
  backgroundImage?: string;
  titleColor?: string;
  title?: string;
  summary?: string;
  arrow?: boolean;
  "data-testid"?: string;
};

export const Banner = ({
  onClick,
  startIconSVG: Svg,
  backgroundColor = "#FFFFFF",
  backgroundImage = "",
  titleColor = isDarkColorRgb(backgroundColor) ? "#FFFFFF" : "#000000",
  title = "",
  summary = "",
  arrow = false,
  "data-testid": dataTestId,
}: BannerProps) => {
  const content = (
    <div className="flex h-9 cursor-pointer flex-col gap-0.5 overflow-hidden whitespace-nowrap">
      <h3 className="overflow-hidden text-ellipsis text-bold2">{title}</h3>
      <h4 className="overflow-hidden text-ellipsis text-body3">{summary}</h4>
    </div>
  );

  const renderContent = () => {
    return Svg ? (
      <div className={cx("flex", "items-center", "gap-x-5")}>
        <div className={cx("flex h-8 items-center")}>
          <Svg className={cx("h-8")} />
        </div>
        {content}
      </div>
    ) : (
      content
    );
  };

  const renderArrow = () =>
    arrow && (
      <Icon
        className="flex"
        size="xsmall"
        svg={ChevronRight}
        color="currentColor"
      />
    );

  const style = {
    color: titleColor,
    backgroundColor: backgroundImage ? "none" : backgroundColor,
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : "initial",
  };

  return (
    <section
      className={cx(
        "flex",
        "items-center",
        "justify-between",
        "cursor-pointer",
        "gap-x-6",
        "p-3",
        "pl-5",
        backgroundImage && "bg-cover bg-center"
      )}
      onClick={onClick}
      data-testid={dataTestId}
      style={style}
    >
      {renderContent()}
      {renderArrow()}
    </section>
  );
};
